export class FreewheelPauseAdConstants {
    static _instance = new FreewheelPauseAdConstants();
    constructor() {
        if (FreewheelPauseAdConstants._instance) {
            throw new Error(this.name +
                ' is a Singleton and can only be accessed through ' +
                this.name +
                '.getInstance()');
        }
        FreewheelPauseAdConstants._instance = this;
    }
    get name() {
        return 'FreewheelPauseAdConstants';
    }
    get capabilitiesFlag() {
        return '+amcb+emcr+dtrd+slcb+vicb+fbad+sync+nucr+aeti';
    }
    get response() {
        return 'vast4';
    }
    get pageView() {
        return `${this.randomTag}`;
    }
    get videoPlayer() {
        return `${this.randomTag}`;
    }
    get randomTag() {
        const max = 10 ** 16;
        const min = 10 ** 9;
        return Math.floor(Math.random() * (max - min - 2)) + min;
    }
    get commonSlotParams() {
        return {
            maxa: '1',
            slid: 'pause_ads-1018x674',
            ptgt: 'a',
            tpcl: 'PAUSE_MIDROLL',
            slau: 'PAUSE_AD'
        };
    }
    get desktopSlotDimensions() {
        return {
            w: '1018',
            h: '674'
        };
    }
    get stvSlotDimensions() {
        return {
            w: '1018',
            h: '674'
        };
    }
    static getInstance() {
        return FreewheelPauseAdConstants._instance;
    }
}
